(async () => {
    const svgSpriteContainer = document.querySelector('[data-svg-sprite-container]');

    if (svgSpriteContainer) {
        const svgSprite = await fetch('/svg-sprite.svg');

        svgSpriteContainer.innerHTML = await svgSprite.text();
    }
})();
